// extracted by mini-css-extract-plugin
export default {"mobile__container":"styles_mobile__container__EcGHO","widget__container":"styles_widget__container__g0hvo"};